import Swiper from "swiper";
import { Navigation, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/thumbs";

export class PumpPage {
    constructor() {
        const thumbsSlider = new Swiper(".pump-thumb-swiper", {
            spaceBetween: 16,
            slidesPerView: "auto",
            modules: [Thumbs],
        });

        new Swiper(".pump-swiper", {
            navigation: {
                nextEl: ".pump-swiper-button-next",
                prevEl: ".pump-swiper-button-prev",
            },
            thumbs: {
                swiper: thumbsSlider,
            },
            modules: [Navigation, Thumbs],
        });
    }
}
